export const INSURANCE_INTERNAL_STATUS = {
  PENDING: "pending", // 대기
  REVIEW: "review", // 검토중
  CONFIRM: "confirm", // 승인
  REJECT: "reject", // 거절
  CANCEL: "cancel", // 취소
  FREE_MONTH: "free_month", // 첫달무료 대기 상태
};
export const INSURANCE_INTERNAL_STATUS_MAPPING = {
  [INSURANCE_INTERNAL_STATUS.PENDING]: "대기",
  [INSURANCE_INTERNAL_STATUS.REVIEW]: "검토중",
  [INSURANCE_INTERNAL_STATUS.CONFIRM]: "승인",
  [INSURANCE_INTERNAL_STATUS.REJECT]: "거절",
  [INSURANCE_INTERNAL_STATUS.CANCEL]: "취소",
  [INSURANCE_INTERNAL_STATUS.FREE_MONTH]: "첫달무료",
};

export const INSURANCE_STATUS_KR = {
  PENDING: "대기",
  NORMAL: "정상",
  CANCEL: "취소",
  REVOKE: "철회",
  TERMINATE: "해지",
  MODIFY: "변경",
};

export const INSURANCE_TYPE = {
  LOTTE_LEGAL_001: "lotte_legal_001", // 롯데손해보험 - 롯데법률지원_001.
};
export const INSURANCE_DISPLAY_NAME = {
  [INSURANCE_TYPE.LOTTE_LEGAL_001]: "롯데법률비용지원",
};

export const INSURANCE_CANCEL_TYPE = {
  REVOKE: "revoke",
  TERMINATE: "terminate",
};

export const INSURANCE_PAY_ORDER_STATUS = {
  PENDING: "결제대기",
  COMPLETED: "결제완료",
  FAILED: "결제실패",
  CANCELLED: "결제취소",
  REFUNDED: "결제환불",
};

export const INSURANCE_PAYMENT_TYPE = {
  ONE_TIME: "one_time",
  MONTHLY: "monthly",
};
export const INSURANCE_PAYMENT_TYPE_MAPPING = {
  [INSURANCE_PAYMENT_TYPE.ONE_TIME]: "일시납",
  [INSURANCE_PAYMENT_TYPE.MONTHLY]: "월납",
};
